import { render, staticRenderFns } from "./VerifyUser.vue?vue&type=template&id=ec37b00e&scoped=true&"
import script from "./VerifyUser.vue?vue&type=script&lang=js&"
export * from "./VerifyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec37b00e",
  null
  
)

export default component.exports